const $ = jQuery.noConflict();

'use strict';
const inputForms = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domLocationWidgetInput: $('.location-widget__input-in, .contact-form__box-wrapper-input input, .login-block__right-box-input-in'),
	$domInputTextarea: $('.wpcf7-form input, .wpcf7-form textarea'),
	$domLoginClearButton: $('.js-login-block__right-box-btn-reset'),
	$domLoginInputValue: $('.login-block__right-box-input input'),
	$domLocationWidgetButton: $('.js-location-widget__image'),
	$domLocationWidgetInputFrom: $('#location-widget__input-in-from, #location-widget__input-in-from-sec'),
	$domLocationWidgetInputTo: $('#location-widget__input-in-to, #location-widget__input-in-to-sec'),
	$domInputMainFrom: $('#location-widget__input-in-from'),
	$domInputMainTo: $('#location-widget__input-in-to'),
	$domInputMainDate: $('#location-widget__input-in-date'),
	$domInputMainType: $('#location-widget__input-in-type'),
	$domInputMainTypeTxt: $('#location-widget__input-in-type-calc'),
	$domInputSecFrom: $('#location-widget__input-in-from-sec'),
	$domInputSecTo: $('#location-widget__input-in-to-sec'),
	$domInputSecDate: $('#location-widget__input-in-date-sec'),
	$domInputSecType: $('#location-widget__input-in-type-sec'),
	$domInputCF7TypeText: $('#location-widget__input-in-type-calc-sec'),
	$domInputCF7From: $('.contact-form__box-wrapper-input--from input'),
	$domInputCF7To: $('.contact-form__box-wrapper-input--to input'),
	$domInputCF7Date: $('.contact-form__box-wrapper-input--date input'),
	$domInputCF7Type: $('.contact-form__box-wrapper-input--type input'),
	classActive: 'is-active',

	/** @description Initialize */
	init: function() {
		this.inputOnFocus();
		this.errorScrollTo();
		this.inputEmptyValue();
		this.inputSwitchValue();
		this.saveInputValues();
		this.retrieveInputValues();
		this.retrieveInputValuesCF7();
	},

	inputOnFocus: function() {
		inputForms.$domLocationWidgetInput.each(function(e, el) {
			$(el).on('focus', function() {
				$(el).parent().closest('div').addClass(inputForms.classActive);
			});
			$(el).on('focusout', function() {
				$(el).parent().closest('div').removeClass(inputForms.classActive);
			});
		});
	},

	errorScrollTo: function() {
		document.addEventListener('wpcf7invalid', function() {
			setTimeout(function() {
				$('html').stop().animate({
					scrollTop: $('.wpcf7-not-valid').eq(0).offset().top - 180,
				}, 500, 'swing');
			}, 100);
		}, false);
	},

	formAutofill: function() {
		inputForms.$domInputTextarea.attr('autocomplete', 'negative');
	},

	inputEmptyValue: function() {
		inputForms.$domLoginClearButton.on('click', function() {
			inputForms.$domLoginInputValue.val('');
			$('.login-block__right-box-input-label').removeClass('is-moved');
		});
	},

	inputSwitchValue: function() {
		inputForms.$domLocationWidgetButton.on('click', function() {
			const pickup = $('#select2-location-widget__input-in-from-container').text();
			const to = $('#select2-location-widget__input-in-to-container').text();
			// const fromSelect = $('#location-widget__input-in-from');
			// const toSelect = $('#location-widget__input-in-to');
			$(this).parent().toggleClass('items-swapped');

			if(!$(this).parent().hasClass('items-swapped')) {
				$('.js-location-widget__input--big-first, .js-first-select').insertBefore('.js-location-widget__image');
				$('.js-location-widget__input--big-second, .js-second-select').insertAfter('.js-location-widget__image');
				$('.js-location-widget__image-txt-switch').text('Export');
			} else {
				$('.js-location-widget__input--big-first, .js-first-select').insertAfter('.js-location-widget__image');
				$('.js-location-widget__input--big-second, .js-second-select').insertBefore('.js-location-widget__image');
				$('.js-location-widget__image-txt-switch').text('Import');
			}

			// $('#select2-location-widget__input-in-from-container').text(to);
			// $('#select2-location-widget__input-in-to-container').text(pickup);
			// $('#location-widget__input-in-from').val(to).trigger('change');
			// $('#location-widget__input-in-to').val(pickup).trigger('change');

			// console.log($('#location-widget__input-in-to').val());


		});
	},

	saveInputValues: function() {
		$('.js-location-widget__wrap-btn').on('click', function() {
			/* localStorage.clear(); */
			localStorage.removeItem('input1');
			const inputMainFrom = $('#location-widget__input-in-from').val();
			const inputMainTo = $('#location-widget__input-in-to').val();
			const inputMainDate = inputForms.$domInputMainDate.val();
			const inputMainType = inputForms.$domInputMainType.val();
			const inputMainTypeTxt = inputForms.$domInputMainTypeTxt.val();
			const switched = $('.location-widget__wrap').hasClass('items-swapped') ? 'switched' : '';
			localStorage.setItem('input1', inputMainTo + '_' + inputMainFrom + '_' + inputMainDate + '_' + inputMainType + '_' + inputMainTypeTxt + '_' + switched);
		});
	},

	retrieveInputValues: function() {
		const storedValue = localStorage.getItem('input1');

		if($('.location-widget--alt').length && storedValue) {
			const storedValueArray = storedValue.split('_');
			console.log(storedValueArray);

			if(!storedValueArray[5]) {
				$('.js-first-select').insertBefore('.js-location-widget__image');
				$('.js-second-select').insertAfter('.js-location-widget__image');
				inputForms.$domInputSecFrom.val(storedValueArray[1]);
				inputForms.$domInputSecTo.val(storedValueArray[0]);
				// console.log(inputForms.$domInputSecTo.val());
			} else {
				$('.location-widget__wrap').addClass('items-swapped');
				$('.js-first-select').insertAfter('.js-location-widget__image');
				$('.js-second-select').insertBefore('.js-location-widget__image');
				inputForms.$domInputSecFrom.val(storedValueArray[0]);
				inputForms.$domInputSecTo.val(storedValueArray[1]);
				// console.log(inputForms.$domInputSecTo.val());
			}

			inputForms.$domInputSecDate.val(storedValueArray[2]);
			inputForms.$domInputSecType.val(storedValueArray[3]);
			inputForms.$domInputCF7TypeText.val(storedValueArray[4]);

			// console.log(storedValueArray[1]);

			setTimeout(() => {
				$('.js-contact-form__box-wrapper-input--type-cargo input').val(storedValueArray[4]);
			}, 2000);
			/* localStorage.removeItem('input1'); */
		}
	},

	retrieveInputValuesCF7: function() {
		const storedValue = localStorage.getItem('input1');
		const placeholder = window.placeholderText;
		let codeFirst;
		let codeSecond;
		let txtValFirst;
		let txtValSecond;

		$('.js-request-quote').on('click', function(e) {
			// e.preventDefault();
			const city1 = $('#select2-location-widget__input-in-from-container').text();
			const city2 = $('#select2-location-widget__input-in-to-container').text();

			if($('.js-date-new').val() === '' || $('.js-type').val() === '' || city1 === placeholder || city2 === placeholder) {
				$('.location-widget.location-widget--alt').addClass('validation-error');
				e.preventDefault();
				$('html').stop().animate({
					scrollTop: $('.location-widget.location-widget--alt.validation-error').eq(0).offset().top - 180,
				}, 500, 'swing');
				return;
			}

			if(city1 === city2 && city1 !== placeholder && city2 !== placeholder) {
				$('.location-widget__input').addClass('error');
				$('.location-widget.location-widget--alt').removeClass('validation-error');
				e.preventDefault();
				// Scroll to .location-widget__input.error element
				$('html').stop().animate({
					scrollTop: $('.location-widget__input.error').eq(0).offset().top - 180,
				}, 500, 'swing');
				return;
			}

			$('.location-widget__input').removeClass('error');
			$('.location-widget.location-widget--alt').removeClass('validation-error');

			if($('.location-widget--alt').length && storedValue) {
				const storedValueArray = storedValue.split('_');

				if(!storedValueArray[5]) {
					inputForms.$domInputCF7From.val(storedValueArray[1]);
					inputForms.$domInputCF7To.val(storedValueArray[0]);

				} else {
					inputForms.$domInputCF7From.val(storedValueArray[0]);
					inputForms.$domInputCF7To.val(storedValueArray[1]);
				}

				inputForms.$domInputCF7Date.val(storedValueArray[2]);
				inputForms.$domInputCF7Type.val(storedValueArray[4]);
				/* localStorage.removeItem('input1'); */
			}

			if ($('.location-widget--alt').length && storedValue) {
				if(!$('.js-location-select').hasClass('select-changed')) {
					codeFirst = localStorage.getItem('codeSecond');
					txtValFirst = $('#select2-location-widget__input-in-from-container').text().toUpperCase() + ` (${codeFirst})`;
				} else {
					codeFirst = inputForms.$domInputCF7From.val();
					txtValFirst = inputForms.$domInputCF7From.val().toUpperCase();
				}

				if(!$('.js-location-select-second').hasClass('select-changed')) {
					codeSecond = localStorage.getItem('code');
					txtValSecond = $('#select2-location-widget__input-in-to-container').text().toUpperCase() + ` (${codeSecond})`;
				}else {
					codeSecond = inputForms.$domInputCF7To.val();
					txtValSecond = inputForms.$domInputCF7To.val().toUpperCase();
				}
			}

			if($('.location-widget--alt').length && storedValue) {
				const storedValueArray = storedValue.split('_');

				if (!storedValueArray[5] && !$('.location-widget__wrap').hasClass('items-swapped')) {
					inputForms.$domInputCF7From.val(txtValFirst);
					inputForms.$domInputCF7From.text(txtValFirst);
					inputForms.$domInputCF7From.attr('value', txtValFirst);
					/* localStorage.removeItem('input1'); */
					/* localStorage.removeItem('code'); */
					//console.log('1');

					inputForms.$domInputCF7To.val(txtValSecond);
					inputForms.$domInputCF7To.text(txtValSecond);
					inputForms.$domInputCF7To.attr('value', txtValSecond);
					/* localStorage.removeItem('input1'); */
					/* localStorage.removeItem('codeSecond'); */
				} else if (storedValueArray[5] && !$('.location-widget__wrap').hasClass('items-swapped')) {
					inputForms.$domInputCF7From.val(txtValFirst);
					inputForms.$domInputCF7From.text(txtValFirst);
					inputForms.$domInputCF7From.attr('value', txtValFirst);
					/* localStorage.removeItem('input1'); */
					/* localStorage.removeItem('code'); */
					console.log('1');

					inputForms.$domInputCF7To.val(txtValSecond);
					inputForms.$domInputCF7To.text(txtValSecond);
					inputForms.$domInputCF7To.attr('value', txtValSecond);
				} else {
					inputForms.$domInputCF7From.val(txtValSecond);
					inputForms.$domInputCF7From.text(txtValSecond);
					inputForms.$domInputCF7From.attr('value', txtValSecond);
					/* localStorage.removeItem('input1'); */
					/* localStorage.removeItem('code'); */
					console.log('2');

					inputForms.$domInputCF7To.val(txtValFirst);
					inputForms.$domInputCF7To.text(txtValFirst);
					inputForms.$domInputCF7To.attr('value', txtValFirst);
					/* localStorage.removeItem('input1'); */
					/* localStorage.removeItem('codeSecond'); */
				}
			}

			if(!storedValue && $('.location-widget__wrap')) {
					const to = localStorage.getItem('cityTo').toUpperCase();
					const from = localStorage.getItem('cityFrom').toUpperCase();

					inputForms.$domInputCF7From.val(from);
					inputForms.$domInputCF7From.text(from);

					inputForms.$domInputCF7To.val(to);
					inputForms.$domInputCF7To.text(to);
			}

			if(!storedValue && $('.location-widget__wrap').hasClass('items-swapped')) {
				if (localStorage.getItem('cityTo') || localStorage.getItem('cityFrom')) {
					const to = localStorage.getItem('cityTo').toUpperCase();
					const from = localStorage.getItem('cityFrom').toUpperCase();

					inputForms.$domInputCF7From.val(to);
					inputForms.$domInputCF7From.text(to);

					inputForms.$domInputCF7To.val(from);
					inputForms.$domInputCF7To.text(from);
				}

			}

			inputForms.$domInputCF7Date.val(inputForms.$domInputSecDate.val());
			/* localStorage.removeItem('input1'); */

			inputForms.$domInputCF7Type.val(inputForms.$domInputSecType.val());
			/* localStorage.removeItem('input1'); */

			$('.js-contact-form__box-wrapper-input--type-cargo input').val($('.js-type-calc').val());
		});
	}
};

export default inputForms;
